<template>
  <div :class="['form__field', { '--hint': hint }]">
    <label :for="name" class="visually-hidden">{{ label }}</label>
    <input
      :id="name"
      class="form__input"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :type="type"
      @blur="validateField"
      @input="valueChange"
      :value="modelValue"
      :autocomplete="name"
    />
    <Icon v-if="icon" :id="icon" class="form__icon" />
    <FormHint :hint="hint" />
  </div>
</template>

<script>
import { FormHint } from '@/components/form/extra'
import { DefaultFormFieldProps, FieldValidation } from '@/components/form/mixins'
import { Icon } from '@/components/global'

export default {
  name: 'FormInput',
  components: { FormHint, Icon },
  mixins: [DefaultFormFieldProps, FieldValidation],
  props: {
    hint: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['email', 'tel', 'text'].includes(value),
    },
  },
  computed: {
    icon() {
      switch (this.name) {
        case 'email':
          return 'email'
        case 'phone':
          return 'phone'
        default:
          return null
      }
    },
  },
}
</script>
